<template>
  <div>
    <b-button
      variant="outline-primary"
      size="sm"
      class="pull-right"
      @click="showComplex = true"
    >
      <i class="fa fa-pencil" /> Bewerk complex
    </b-button>
    <b-modal
      v-model="showComplex"
      :size="modus == 'Uit complex' && verplaatsing == 'Bestaand' ? 'xl' : 'lg'"
      :ok-disabled="!validateOkButton"
      :ok-title="modus == 'Uit complex' ? 'Afsplitsen' : 'Opslaan'"
      title="Complex"
      cancel-title="Annuleren"
      role="tablist"
      @ok="modus == 'Uit complex' ? transferToComplex() : saveComplex()"
    >
      <b-radio-group
        v-model="modus"
        :options="['Binnen complex', 'Uit complex']"
        buttons
      />

      <b-card-sub-title 
        v-if="modus == 'Uit complex'" 
        class="my-4"
      >
        Afsplitsen van units naar een ander complex
      </b-card-sub-title>
      <b-card-sub-title 
        v-if="modus == 'Binnen complex'" 
        class="my-4"
      >
        Complex bewerken en volgorde unitnummering
      </b-card-sub-title>

      <b-row>
        <b-col 
          v-if="modus == 'Binnen complex'" 
          cols="5"
        >
          <b-form-group 
            :description="`${complex.Huismeester.length}/100 en ${complex.Telefoon.length}/20`" 
            label="Huismeester"
          >
            <b-input-group>
              <b-input
                v-model.trim="complex.Huismeester"
                maxlength="100"
                type="text"
                placeholder="Naam"
              />
              <b-input
                v-model.trim="complex.Telefoon"
                maxlength="20"
                type="text"
                placeholder="Telefoonnummer"
              />
            </b-input-group>
          </b-form-group>

          <b-form-group 
            :description="`${complex.ComplexNummer.length}/15`" 
            label="Complexnummer"
          >
            <b-input-group>
              <b-input
                v-model.trim="complex.ComplexNummer"
                maxlength="15"
                type="text"
                placeholder="Complexnummer"
              />
            </b-input-group>
          </b-form-group>

          <b-form-group label="Relatie">
            <b-select
              v-model="complex.Relatie.Id"
              :options="relatieOpties"
              text-field="label"
              value-field="value"
              placeholder="Kies een relatie"
            >
              <template #first>
                <b-form-select-option 
                  :value="null" 
                  disabled
                >
                  -- Kies een relatie --
                </b-form-select-option>
              </template>
            </b-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-list-group flush>
            <b-list-group-item
              v-for="(item, index) of complex.Units"
              :key="index"
            >
              <b-input-group>
                <b-input-group-prepend 
                  v-if="modus == 'Uit complex'" 
                  is-text
                >
                  <b-checkbox 
                    v-model="units" 
                    :value="item"
                  />
                </b-input-group-prepend>
                <b-input-group-addon 
                  v-else
                >
                  <b-select
                    v-model="item.Nummer"
                    :options="
                      Array.apply(null, Array(complex.Units.length)).map(
                        function (_, i) {
                          return i + 1;
                        }
                      )
                    "
                  />
                </b-input-group-addon>
                <b-input-group-text>
                  {{ item.Kenmerk }} {{ item.Adres }}
                </b-input-group-text>
              </b-input-group>
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col
          v-if="modus == 'Uit complex'"
          :cols="verplaatsing == 'Bestaand' ? 7 : 6"
        >
          <b-form-group label="Selecteer het complex">
            <b-radio-group
              v-model="verplaatsing"
              :options="['Nieuw', 'Bestaand']"
            />
          </b-form-group>
          <b-form-group v-if="verplaatsing == 'Nieuw'">
            <b-input
              v-model="nieuwnummer"
              placeholder="Nieuw complex nummer"
            />
          </b-form-group>
          <b-form-group v-if="verplaatsing == 'Bestaand'">
            <b-input-group>
              <b-input
                v-model="zoekterm"
                type="search"
                debounce="200"
                placeholder="Zoek op complexnummer"
              />
              <b-input-group-text>Beginnend met een</b-input-group-text>
              <b-input-group-addon>
                <b-radio-group
                  v-model="groep"
                  :options="['T', 'D', 'C']"
                  buttons
                />
              </b-input-group-addon>
            </b-input-group>
          </b-form-group>
          <complex-selectie
            v-if="verplaatsing == 'Bestaand'"
            :zoekterm="zoekterm"
            :groep="groep"
            @complex-geselecteerd="naarComplex = $event"
          />
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";
import ComplexSelectie from "@/components/ComplexSelectie";
import { StandardFontValues } from "pdf-lib";
export default {
  components: { ComplexSelectie },
  mixins: [serviceMixin],
  props: {
    complex: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      relaties: [],
      zoekterm: "",
      nieuwnummer: "",
      naarComplex: null,
      units: [],
      groep: "D",
      showComplex: false,
      verplaatsing: "Nieuw",
      modus: "Binnen complex",
    };
  },
  computed: {
    validateOkButton: function () {
      if (this.modus == "Binnen complex") {
        return true;
      } else if (this.modus == "Uit complex") {
        if (this.units.length == 0) return false;
        if (this.verplaatsing == "Nieuw") return this.nieuwnummer.length > 0;
        if (this.verplaatsing == "Bestaand") return this.naarComplex;
        return true;
      }
      return StandardFontValues;
    },
    relatieOpties: function () {
      return this.relaties.map(function (item) {
        return {
          label: item.Naam,
          value: item.Id,
        };
      });
    },
  },
  mounted() {
    this.getRelaties();
  },
  methods: {
    getRelaties() {
      var vm = this;
      this.get("/relaties")
        .then(function (response) {
          console.log(response);
          vm.relaties = response.data.relaties;
        })
        .catch(function (error) {
          vm.error = error;
        });
    },
    saveComplex() {
      console.log("saveComplex");
      this.$emit("save-complex");
    },
    transferToComplex() {
      var vm = this;
      console.log("transferToComplex");
      var url = `/complexen/${this.complex.Id}/transfer`;
      console.log(url);
      var data = {
        units: this.units,
        data: {
          nieuwnummer: this.nieuwnummer,
          naarComplex: this.naarComplex,
        },
      };

      if (this.verplaatsing == "Nieuw") {
        this.post(url + "/nieuw", data)
          .then(function (response) {
            console.log(response.data);
            vm.$emit("update-complex", response.data.complex);
          })
          .catch(function (error) {
            vm.error = error;
          });
      }
      if (this.verplaatsing == "Bestaand") {
        this.post(url + "/bestaand", data)
          .then(function (response) {
            console.log(response.data);
            vm.$emit("update-complex", response.data.complex);
          })
          .catch(function (error) {
            vm.error = error;
          });
      }
    },
  },
};
</script>